import React from 'react'

import { Box } from 'widgets/Box'
import { ButtonProps } from 'widgets/Button'
import { Modal } from 'widgets/Modal'
import { Text } from 'widgets/Text'

type Props = {
  handleClose: () => void
  open: boolean
  handleYes: () => void
  mode: 'pending' | 'active'
}

export const MembershipModal = ({ handleClose, open, handleYes, mode }: Props) => {
  const actionButtonProps: ButtonProps[] = [
    {
      title: 'No',
      type: 'grey',
      onPress: handleClose,
    },
    {
      title: 'Yes',
      type: 'v2primary',
      onPress: () => {
        handleYes()
        handleClose()
      },
    },
  ]

  return (
    <Modal actionButtonProps={actionButtonProps} isVisible={open} onClose={handleClose}>
      <Box padding='xs' margin={{ horizontal: 'md', vertical: 'sm' }}>
        {mode === 'pending' && (
          <Text>Are you sure you want to delete this from your pending Groups?</Text>
        )}
        {mode === 'active' && <Text>Are you sure you want to leave this Group?</Text>}
      </Box>
    </Modal>
  )
}
